import { createTheme } from '@mui/material/styles';

import { darkTheme } from './themes/dark';
import { lightTheme } from './themes/light';

export enum THEME_TYPE {
  LIGHT = 'light',
  DARK = 'dark'
}

export const THEMES = {
  [THEME_TYPE.LIGHT]: createTheme(lightTheme),
  [THEME_TYPE.DARK]: createTheme(darkTheme),
};